<script>
import anime from "animejs"
// let orderBy = require("lodash/fp/orderby");
// let collection = require("lodash/fp/collection");
// import _ from "lodash";

export default {
	name: "standards-table",
	data() {
		return {
			keys: [
				{ name: "Status", slug: "status" },
				{ name: "Year", slug: "year" },
				{ name: "Title", slug: "title" },
				{ name: "Product", slug: "product" },
				{ name: "Type", slug: "type" },
				{ name: "Sector", slug: "sector" }
			]
		}
	},
	computed: {
		filteredStandards() {
			return this.$store.getters.filteredStandards
		},
		arrow() {
			return this.$store.getters.sortOrder == "asc" ? "↓" : "↑"
		}
	},
	created() {
		this.$store.dispatch("retrieveStandards")
	},
	methods: {
		order(e) {
			let key = e.srcElement.dataset.key
			this.$store.commit("sortKey", key)
			this.$store.getters.sortOrder == "desc" && key
				? this.$store.commit("sortOrder", "asc")
				: this.$store.commit("sortOrder", "desc")
		},
		beforeEnter: function(el) {
			el.style.opacity = 0
			// el.style.maxHeight = 0;
		},
		enter: function(el, done) {
			var delay = el.dataset.index * 3
			setTimeout(function() {
				anime({
					targets: el,
					opacity: 1,
					// maxHeight: "3em",
					complete: done
				})
			}, delay)
		},
		leave: function(el, done) {
			var delay = el.dataset.index * 2
			setTimeout(function() {
				anime({
					targets: el,
					opacity: 0,
					// maxHeight: "0px",
					complete: done
				})
			}, delay)
		}
	}
}
</script>

<template>
	<div>
		<div class="white-card content">
			<p class="meta">Click to reorder ↓ ↑</p>
			<table class="w-full">
				<thead>
					<tr id="standardsTableHeader">
						<th @click="order" :data-key="key.slug" v-for="key in keys" :key="key.slug" class="table-sort-header text-left py-2 pr-4 cursor-pointer hover:text-black">
							{{ key.name }}
							<span v-if="$store.getters.sortKey == key.slug">{{ arrow }}</span>
						</th>						
					</tr>
				</thead>
				<transition-group
						name="staggered-fade"
						tag="tbody"
						v-if="filteredStandards"
						v-bind:css="false"
						v-on:before-enter="beforeEnter"
						v-on:enter="enter"
					>
					<!-- v-on:leave="leave" -->
					<tr 
						v-for="(standard, index) in filteredStandards" 
						:key="`${standard.url}`"
						:data-index="index"
						>
						<td class="py-2 border-t border-grey-lighter text-sm">
							{{ standard.status }}
						</td>
						<td class="py-2 border-t border-grey-lighter">{{ standard.year }}</td>
						<td class="py-2 border-t border-grey-lighter">
							<a :href="standard.url" :title="`View ${standard.title}`">
								{{ standard.title }}
							</a>
						</td>
						<td class="py-2 border-t border-grey-lighter">{{ standard.product }}</td>
						<td class="py-2 border-t border-grey-lighter">{{ standard.type }}</td>
						<td class="py-2 border-t border-grey-lighter">{{ standard.sector }}</td>
					</tr>
				</transition-group>
			</table>
		</div>
		
	</div>
</template>
